import { createContext } from 'react';
var companyDetails = {
  billingAddress: {
    addressId: '',
    addressLine1: '',
    addressLine2: '',
    alternateNo: '',
    cityName: '',
    contactNumber: '',
    countryCode: '',
    countryName: '',
    districtName: '',
    postalCode: '',
    postalCodeId: '',
    stateCode: '',
    stateIsoCode: '',
    stateName: '',
    landmark: ''
  },
  businessType: '',
  businessTypeId: '',
  compAttributes: [{
    attributeName: '',
    dataType: '',
    id: '',
    required: true,
    valId: '',
    value: ''
  }],
  companyId: '',
  companyName: '',
  companyStatus: '',
  contactDetails: {
    contactDetailsId: '',
    contactNo: '',
    emailId: '',
    salesDeptContactNo: '',
    salesDeptEmailId: ''
  },
  countryCode: '',
  dcsCompanyId: '',
  documents: [{
    docLink: '',
    docTypeId: '',
    documentName: '',
    documentSize: ''
  }],
  panFullName: '',
  role: '',
  shippingAddress: {
    addressId: '',
    addressLine1: '',
    addressLine2: '',
    alternateNo: '',
    cityName: '',
    contactNumber: '',
    countryCode: '',
    countryName: '',
    districtName: '',
    postalCode: '',
    postalCodeId: '',
    stateCode: '',
    stateIsoCode: '',
    stateName: '',
    landmark: ''
  },
  shippingAddressSameAsBilling: false,
  userConsent: false,
  userEmailId: '',
  userFirstName: '',
  userLastName: '',
  userTelephoneNo: '',
  userId: ''
};
var defaultState = {
  companyData: companyDetails,
  setCompanyDetailsFromInput: function setCompanyDetailsFromInput(companyData) {
    return companyData;
  }
};
var CompanyDetailsContext = /*#__PURE__*/createContext(defaultState);
export { CompanyDetailsContext, companyDetails };